/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Box } from '@towersystems/towersystems-design-system';
import page from 'page';

/**
 * Internal dependencies
 */
import Modal from 'components/modal';
import { createCloseModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';
import CreateConnectionForm from 'blocks/create-connection-form';
import { successNotice } from 'state/notices/actions';
import cecSdk from 'lib/customer-ec-sdk';

/**
 * Style dependencies
 */
import './styles.scss';

const CreateConnectionModal = ({ isVisible, close, ...props }) => {
    const [submitting, setSubmitting] = useState(false);
    const [weblinkGroups, setWeblinkGroups] = useState(null);

    const buttons = [
        {
            key: 'cancel',
            label: 'Cancel',
            onClick: close
        },
        {
            key: 'save',
            label: 'Save',
            type: 'submit',
            form: 'create-connection-form',
            disabled: submitting,
        },
    ];

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            let weblinkGroups = await cecSdk.weblinkGroup().getWeblinkGroups();
            setWeblinkGroups(weblinkGroups);
        } catch (error) {
        }
    };

    return (
        <Modal
            title='Create new connection'
            className='create-connection-modal'
            close={close}
            isVisible={isVisible}
            buttons={buttons}
        >
            <Box padding='xlarge'>
                <CreateConnectionForm
                    weblinkGroups={weblinkGroups}
                    beforeSubmit={() => setSubmitting(true)}
                    afterSubmit={() => setSubmitting(false)}
                    afterSuccessfullSubmit={({ id }) => {
                        close();
                        page('/connections/' + id);
                        props.successNotice('Saved')
                    }}
                />
            </Box>
        </Modal>
    );
};

export default connect(
    (state) => ({
        isVisible: isModalVisible('CreateConnectionModal')(state),
    }),
    {
        close: createCloseModalAction('CreateConnectionModal'),
        successNotice
    },
)(CreateConnectionModal);
